import axios from 'axios'
import {
  ResponseBedPseudo,
  ResponseObject,
  ResponseObjectPaginated,
  ResponseObjectUpload,
} from '../../../models'
import {
  BedPseudoDto,
  CampGuestItem,
  CancelChangeColumn,
  CancelChangeTableDto,
} from '../models/cancel-change'
import {ID} from '../../../../../_metronic/helpers'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export function getListBookings(dto: CancelChangeTableDto) {
  return axios.post<ResponseObjectPaginated<CancelChangeColumn[]>>(
    `${BASEURL}/CancelChange/getListReserves`,
    dto,
  )
}

export function getBedPseudoService(dto: BedPseudoDto) {
  return axios.post<ResponseBedPseudo>(`${BASEURL}/cancelChange/getBedPseudo`, dto)
}

export function createCancelChangeService(dto: any) {
  return axios.post<ResponseObjectUpload>(`${BASEURL}/cancelChange/createCancelChange`, dto)
}

export function getListCampsGuestService(guestId: ID) {
  return axios.post<ResponseObject<CampGuestItem[]>>(
    `${BASEURL}/cancelChange/getListCampsGuest?GuestId=${guestId}`,
  )
}
